export const captionFormat = src => ({
  kind: 'captions',
  label: 'Default subtitle',
  src,
  default: true
});
